// Illumination (Illuminance) units with conversion factors to lux (lx)
export const illuminationUnits = [
  { id: 'lux', name: 'Lux', symbol: 'lx', plural: 'Lux', factor: 1 },
  { id: 'meter-candle', name: 'Meter-candle', symbol: 'mc', plural: 'Meter-candles', factor: 1 },
  { id: 'centimeter-candle', name: 'Centimeter-candle', symbol: 'cm·c', plural: 'Centimeter-candles', factor: 10000 },
  { id: 'foot-candle', name: 'Foot-candle', symbol: 'fc', plural: 'Foot-candles', factor: 10.7639104 },
  { id: 'flame', name: 'Flame', symbol: 'flame', plural: 'Flames', factor: 43.0556 },
  { id: 'phot', name: 'Phot', symbol: 'ph', plural: 'Phots', factor: 10000 },
  { id: 'nox', name: 'Nox', symbol: 'nox', plural: 'Nox', factor: 0.001 },
  { id: 'candela-steradian-per-sqmeter', name: 'Candela steradian/sq meter', symbol: 'cd·sr/m²', plural: 'Candela steradian/sq meter', factor: 1 },
  { id: 'lumen-per-sqmeter', name: 'Lumen/Square Meter', symbol: 'lm/m²', plural: 'Lumen/Square Meter', factor: 1 },
  { id: 'lumen-per-sqcentimeter', name: 'Lumen/Square Centimeter', symbol: 'lm/cm²', plural: 'Lumen/Square Centimeter', factor: 10000 },
  { id: 'lumen-per-sqfoot', name: 'Lumen/Square Foot', symbol: 'lm/ft²', plural: 'Lumen/Square Foot', factor: 10.7639104 },
  { id: 'watt-per-sqcentimeter', name: 'Watt/Square Centimeter (at 555 nm)', symbol: 'W/cm²', plural: 'Watt/Square Centimeter', factor: 6830000 },
];

export const popularIlluminationConversions = [
  { from: 'lux', to: 'foot-candle' },
  { from: 'foot-candle', to: 'lux' },
  { from: 'lux', to: 'phot' },
  { from: 'phot', to: 'lux' },
  { from: 'lumen-per-sqfoot', to: 'lux' },
  { from: 'lux', to: 'lumen-per-sqmeter' },
];

export const getUnitById = (id) => illuminationUnits.find(unit => unit.id === id);

export const convertIllumination = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert illumination/illuminance units and learn the conversion formula.`;
};
